var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutosave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_89",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 11H13V4C13 3.71667 12.9041 3.47917 12.7125 3.2875C12.5208 3.09583 12.2833 3 12 3C11.7166 3 11.4791 3.09583 11.2875 3.2875C11.0958 3.47917 11 3.71667 11 4V11ZM4.99998 15H19V13H4.99998V15ZM3.54998 21H5.99998V19C5.99998 18.7167 6.09582 18.4792 6.28748 18.2875C6.47915 18.0958 6.71665 18 6.99998 18C7.28332 18 7.52082 18.0958 7.71248 18.2875C7.90415 18.4792 7.99998 18.7167 7.99998 19V21H11V19C11 18.7167 11.0958 18.4792 11.2875 18.2875C11.4791 18.0958 11.7166 18 12 18C12.2833 18 12.5208 18.0958 12.7125 18.2875C12.9041 18.4792 13 18.7167 13 19V21H16V19C16 18.7167 16.0958 18.4792 16.2875 18.2875C16.4791 18.0958 16.7166 18 17 18C17.2833 18 17.5208 18.0958 17.7125 18.2875C17.9042 18.4792 18 18.7167 18 19V21H20.45L19.45 17H4.54998L3.54998 21ZM20.45 23H3.54998C2.89998 23 2.37498 22.7417 1.97498 22.225C1.57498 21.7083 1.45832 21.1333 1.62498 20.5L2.99998 15V13C2.99998 12.45 3.19582 11.9792 3.58748 11.5875C3.97915 11.1958 4.44998 11 4.99998 11H8.99998V4C8.99998 3.16667 9.29165 2.45833 9.87498 1.875C10.4583 1.29167 11.1666 1 12 1C12.8333 1 13.5416 1.29167 14.125 1.875C14.7083 2.45833 15 3.16667 15 4V11H19C19.55 11 20.0208 11.1958 20.4125 11.5875C20.8041 11.9792 21 12.45 21 13V15L22.375 20.5C22.5917 21.1333 22.4958 21.7083 22.0875 22.225C21.6791 22.7417 21.1333 23 20.45 23Z",
    fill: "#5434B6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutosave);
export default __webpack_public_path__ + "static/media/Autosave.26bd14beb1c9a4109065a24060f16575.svg";
export { ForwardRef as ReactComponent };